import { ExternalButton } from 'app/ui/components/external-button/ExternalButton';
import ViewIcon from 'app/ui_v2/icons/ViewIcon';
import { Link } from 'react-router-dom';

import { SxProps, Theme, useTheme } from '@mui/material';

import { getProjectExternalLink } from '../../inspections/config';

export interface BookingActionsProps {
  id: string;
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    table: {
      width: '100%',
      '& thead th': {
        padding: '16px 24px',
      },
      '& tbody td': {
        padding: '16px',
      },
      '& tbody td:first-of-type': {
        paddingLeft: '24px',
      },
      '& tbody td:last-child': {
        paddingRight: '24px',
      },
    },
    cellHelper: {
      fontSize: '1.2rem',
    },
    noBreak: {
      whiteSpace: 'nowrap',
    },
    view: {
      background: theme.palette.primary.main,
      padding: '4px',
      height: '26px',
      width: '26px',
      borderRadius: '4px',
      marginRight: '24px',
      color: '#fff',
    },
    tableWrapper: {
      width: '100%',
      background: '#fff',
      overflow: 'auto',
    },
    titleCase: {
      textTransform: 'capitalize',
    },
  };
};

export default function BookingActions(props: BookingActionsProps) {
  const { id } = props;

  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <>
      <ExternalButton component={Link} to={getProjectExternalLink(id)}>
        <ViewIcon fontSize="inherit" sx={styles.view} />
      </ExternalButton>
    </>
  );
}
